import { TechnicianType } from "@/hooks/services/pps/types/job-orders.type";

interface UserAvatarProps {
  users?: TechnicianType[];
  limit?: number;
}

export function UserAvatars({ users = [], limit = 3 }: UserAvatarProps) {
  if (!users || users.length === 0) {
    return null;
  }

  const visibleUsers = users.slice(0, limit);

  return (
    <div className="aero:flex aero:-space-x-[8px]">
      {visibleUsers.map((user) => (
        <div
          key={user.id}
          className="aero:h-8 aero:w-8 aero:bg-zinc-200 aero:dark:bg-background aero:dark:ring-zinc-500 aero:!rounded-full aero:flex aero:items-center aero:justify-center aero:ring-2 aero:ring-white"
        >
          <span className="aero:!text-sm aero:!font-medium">
            {user.name.charAt(0).toUpperCase()}
          </span>
        </div>
      ))}
    </div>
  );
}
